export enum OnboardingWizardStepsEnum {
  WELCOME,
  LOCATION_DEPARTMENT,
  ACCOUNT_CODE,
  BUDGET,
  APPROVAL_ROUTING,
  INVITE_USER,
}
